<div class="ziti-page-container ziti-auth-policies-container">
    <lib-list-page-header [title]="title"
                          [tabs]="tabs"
                          [showAdd]="!itemsSelected"
                          (actionClicked)="headerActionClicked($event)"></lib-list-page-header>

    <lib-data-table [tableId]="'auth-policies'"
                    [rowData]="rowData"
                    [columnDefinitions]="columnDefs"
                    (actionRequested)="tableAction($event)"
                    [startCount]="startCount"
                    [endCount]="endCount"
                    [totalCount]="totalCount"
                    [emptyMsg]="'No Auth Policies defined, Click the plus to add a Configuration.'"
                    [filterApplied]="filterApplied"
                    [menuItems]="svc.menuItems"
                    (gridReady)="gridReady($event)"
    >
    </lib-data-table>
</div>
